var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.25C14.25 11.6642 14.5858 12 15 12C15.4142 12 15.75 11.6642 15.75 11.25H14.25ZM15.75 3.75C15.75 3.33579 15.4142 3 15 3C14.5858 3 14.25 3.33579 14.25 3.75H15.75ZM29.25 11.25C29.25 11.6642 29.5858 12 30 12C30.4142 12 30.75 11.6642 30.75 11.25H29.25ZM30.75 3.75C30.75 3.33579 30.4142 3 30 3C29.5858 3 29.25 3.33579 29.25 3.75H30.75ZM15.75 11.25V3.75H14.25V11.25H15.75ZM30.75 11.25V3.75H29.25V11.25H30.75Z",
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 16.875H39.375",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 11.25V35.625C5.625 37.6969 7.30312 39.375 9.375 39.375H35.625C37.6969 39.375 39.375 37.6969 39.375 35.625V11.25C39.375 9.17812 37.6969 7.5 35.625 7.5H9.375C7.30312 7.5 5.625 9.17812 5.625 11.25Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.81 23.4375C26.7937 23.4375 28.125 25.1831 28.125 26.8087C28.125 30.1087 22.6013 32.8125 22.5 32.8125",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.19 23.4375C18.2063 23.4375 16.875 25.1831 16.875 26.8087C16.875 30.1087 22.3987 32.8125 22.5 32.8125",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 24.4408C22.9312 23.9683 23.6756 23.4376 24.81 23.4376",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 24.4408C22.0687 23.9683 21.3243 23.4376 20.1899 23.4376",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationCalendar);
export default __webpack_public_path__ + "static/media/navigation-calendar.75a063e2.svg";
export { ForwardRef as ReactComponent };